<template>
  <div>
    <div
      class="modal fade"
      id="customConfirmModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="customConfirmLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="customConfirmLabel">Confirmação</h5>
          </div>
          <div class="modal-body">
            <p>{{ message }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" @click="cancel">Cancelar</button>
            <button type="button" class="btn btn-blue" @click="confirm">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";

export default {
  name: "CustomConfirm",
  data() {
    return {
      message: "",
      modalInstance: null,
      previousModal: null,
      previousModalInstance: null,
      resolve: null,
      reject: null,
    };
  },
  mounted() {
    const modalElement = document.getElementById("customConfirmModal");
    this.modalInstance = new Modal(modalElement, {
      backdrop: "static",
      keyboard: false,
    });

    modalElement.addEventListener("hidden.bs.modal", this.cleanModalState);
  },
  beforeRouteLeave(to, from, next) {
    this.dismissModal();
    next();
  },
  beforeUnmount() {
    const modalElement = document.getElementById("customConfirmModal");
    if (modalElement) {
      modalElement.removeEventListener("hidden.bs.modal", this.cleanModalState);
    }
    this.dismissModal();
  },
  methods: {
    open(message) {
      this.message = message;

      this.previousModal = document.querySelector(".modal.show");
      if (this.previousModal) {
        this.previousModalInstance = Modal.getInstance(this.previousModal);
        this.previousModalInstance.hide();
      }

      this.modalInstance.show();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    confirm() {
      this.modalInstance.hide();
      if (this.resolve) this.resolve(true);
    },
    cancel() {
      this.modalInstance.hide();
      if (this.previousModalInstance && this.previousModalInstance.show) {
        this.previousModalInstance.show();
      }
      if (this.reject) this.reject(false);
    },
    dismissModal() {
      if (this.modalInstance) {
        this.modalInstance.hide();
        this.modalInstance.dispose();
        this.modalInstance = null;
      }
      this.cleanModalState();
    },
    cleanModalState() {
      this.message = "";
      this.previousModal = null;
      this.previousModalInstance = null;
      this.resolve = null;
      this.reject = null;
    },
  },
};
</script>

<style scoped>
.modal-body {
  text-align: center;
}
</style>
